import { PieChartOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsCapacityProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsCapacityComponent = ({ veranstaltung }: VeranstaltungsCapacityProps) => (
  <CustomAccordion title="Kapazität" icon={PieChartOutlined} open={false}>
    <Grid container spacing={1} rowSpacing={-5}>
      <Grid size={5}>Min:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.capacitymin}</b>
      </Grid>
      <Grid size={5}>Max:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.capacitymax}</b>
      </Grid>
      <Grid size={5}>Optimal:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.capacityoptimal}</b>
      </Grid>
      <Grid size={5}>Erwartet:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.capacityexpected}</b>
      </Grid>
    </Grid>
  </CustomAccordion>
);
